import { render, staticRenderFns } from "./ClientCityInfo.vue?vue&type=template&id=bbbda744&scoped=true&"
import script from "./ClientCityInfo.vue?vue&type=script&lang=js&"
export * from "./ClientCityInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClientCityInfo.vue?vue&type=style&index=0&id=bbbda744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbda744",
  null
  
)

export default component.exports